import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_PERSONEL_DATA: '/GetPersonelData',
  GET_PERSONEL_EXCEL_DATA: '/GetPersonelExcelData',
  GET_GUNLUK_IS_TAKIP: '/GunlukIsTakip',
  GET_GUNLUK_IS_TAKIP_EXPORT: '/GunlukIsTakipExport',
}

export const getPersonelData = async (params = {}) => {
  const { offset = 0, days, search = '', userids, date, bloklamasebebi, ilce, mah, sokak, adress } = params;
  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_PERSONEL_DATA}?offset=${offset}`;
  
  // Add userids if they exist, properly encoding the # character
  if (userids) {
    url += `&userids=${encodeURIComponent(userids)}`;
  } else {
    url += `&userids=${undefined}`;
  }

  if (days !== undefined && days !== '') url += `&days=${days}`;
  if (search !== undefined && search !== '') url += `&search=${search}`;
  if (date !== undefined && date !== '') url += `&date=${date}`;
  if (bloklamasebebi !== undefined && bloklamasebebi !== '') url += `&bloklamasebebi=${bloklamasebebi}`;
  if (ilce !== undefined && ilce !== '') url += `&ilce=${ilce}`;
  if (mah !== undefined && mah !== '') url += `&mah=${mah}`;
  if (sokak) {
    url += `&sokak=${encodeURIComponent(sokak)}`;
  }
  if (adress !== undefined && adress !== '') url += `&adress=${adress}`;

  const response = await fetch(url, {
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Personel verileri alınamadı');
  }

  return response.json();
}

export const getPersonelExcelData = async (params = {}) => {
  const { offset = 0, days, search = '', userids, date, bloklamasebebi, ilce, mah, sokak, adress } = params;
  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_PERSONEL_EXCEL_DATA}?offset=${offset}`;
  
  // Add userids if they exist, properly encoding the # character
  if (userids) {
    url += `&userids=${encodeURIComponent(userids)}`;
  } else {
    url += `&userids=${undefined}`;
  }

  if (days !== undefined && days !== '') url += `&days=${days}`;
  if (search !== undefined && search !== '') url += `&search=${search}`;
  if (date !== undefined && date !== '') url += `&date=${date}`;
  if (bloklamasebebi !== undefined && bloklamasebebi !== '') url += `&bloklamasebebi=${bloklamasebebi}`;
  if (ilce !== undefined && ilce !== '') url += `&ilce=${ilce}`;
  if (mah !== undefined && mah !== '') url += `&mah=${mah}`;
  if (sokak) {
    url += `&sokak=${encodeURIComponent(sokak)}`;
  }
  if (adress !== undefined && adress !== '') url += `&adress=${adress}`;

  const response = await fetch(url, {
    headers: {
      'accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Excel verileri alınamadı');
  }

  // Get the blob from the response
  return response.blob();
}

export const getWasteDataExcel = async (days) => {
    try {
      let url;
      if (days === 0) {
        url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_WASTE_DATA_EXCEL}?days=0`;
      } else {
        url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_WASTE_DATA_EXCEL}${days ? `?days=${days}` : ''}`;
      }
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
  
      if (!response.ok) {
        throw new Error('Excel indirme işlemi başarısız oldu');
      }
  
      // Get the filename from the content-disposition header
      const contentDisposition = response.headers.get('content-disposition');
      const filenameMatch = contentDisposition && contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      // Get current date for filename
      const today = new Date();
      const date = today.toISOString().split('T')[0];
      const filename = filenameMatch && filenameMatch[1] ? filenameMatch[1].replace(/['"]/g, '') : `Atik_Verileri_${date}.xlsx`;
  
      // Convert response to blob
      const blob = await response.blob();
      
      // Create a download link and trigger it
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
  
      return true;
    } catch (error) {
      console.error('Excel download error:', error);
      throw error;
    }
};

export const getGunlukIsTakip = async () => {
  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_GUNLUK_IS_TAKIP}`;
  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Günlük iş takip verileri alınamadı');
  }

  return response.json();
}

export const getGunlukIsTakipExport = async () => {
  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_GUNLUK_IS_TAKIP_EXPORT}`;
  const response = await fetch(url, {
    headers: {
      'accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Excel indirme işlemi başarısız oldu');
  }

  return response.blob();
}
